module.exports = __webpack_public_path__ + "fonts/GeogrotesqueCyr-Regular.f8ac7d88.woff";